package com.parmartechnologies.commerce.feature.customer.viewModel

import com.parmartechnologies.core.feature.customer.model.Customer
import com.parmartechnologies.core.feature.customer.network.CreateCustomerRequest
import com.parmartechnologies.core.feature.customer.network.FetchCustomerRequest
import com.parmartechnologies.core.feature.customer.network.FindCustomerRequest
import com.parmartechnologies.core.feature.customer.network.UpdateCustomerRequest
import com.parmartechnologies.core.app.AppViewModel
import com.parmartechnologies.commerce.feature.customer.handler.CustomerHandler
import com.parmartechnologies.commerce.feature.customer.network.CustomerNetwork
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.storage.constant.KeyConstant
import com.parmartechnologies.storage.store.UserDefaults
import com.parmartechnologies.storage.table.customer.CustomerDatabaseTable
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import kotlin.time.ExperimentalTime

class CustomerViewModel(val business: Business) : AppViewModel() {

    val repository = CustomerHandler.shared().repository

    val allCustomer: StateFlow<List<Customer>>
        get() = repository.allCustomer

    val customer: StateFlow<Customer?>
        get() = repository.customer

    val selectedCustomer: StateFlow<Customer?>
        get() = repository.selectedCustomer

    val editCustomer: StateFlow<Customer?>
        get() = repository.editCustomer
    val searchQuery: StateFlow<String>
        get() = repository.searchQuery

    override fun changeSearchQuery(value: String) {
        scope.launch {
            repository.searchQueryState.emit(value)
        }
        performSearch(value)
    }

    override fun performSearch(value: String) {
        scope.launch {
            CustomerDatabaseTable().search(business._id, value) { items ->
                scope.launch {
                    repository.allCustomerState.emit(items)
                }
            }
        }
    }

    fun setSelectedCustomer(value: Customer?) {
        scope.launch {
            repository.selectedCustomerState.emit(value)
        }
    }

    fun editCustomer(value: Customer?) {
        repository.setEditCustomer(value)
    }

    fun editCustomerName(value: String) {
        repository.editCustomer.value?.Name = value
    }

    fun editCustomerMobile(value: String) {
        repository.editCustomer.value?.MobileNumber = value
    }

    fun editCustomerDialCode(value: String) {
        repository.editCustomer.value?.DialCode = value
    }

    fun editCustomerEmail(value: String) {
        repository.editCustomer.value?.EmailID = value
    }

    fun editCustomerBarcode(value: String) {
        repository.editCustomer.value?.Barcode = value
    }

    fun loadCustomers() {
        loadCustomersFromStorage()
        startLoading()
            val request = FetchCustomerRequest(
                business._id,
                ""
            )
            scope.launch {
                CustomerNetwork().retrieveCustomer(request) {
                    stopLoading()
                    if (it?.payload?.isNotEmpty() == true) {
                        scope.launch {
                            CustomerDatabaseTable().insert(it.payload)
                            loadCustomersFromStorage()
                        }
                    }
                }
            }

    }
    fun loadMoreCustomers() {
        loadCustomersFromStorage()
        startLoading()
        CustomerDatabaseTable().LastSyncDate(business._id) { date ->
            val request = FetchCustomerRequest(
                business._id,
                date ?: ""
            )
            scope.launch {
                CustomerNetwork().retrieveCustomer(request) {
                    stopLoading()
                    if (it?.payload?.isNotEmpty() == true) {
                        scope.launch {
                            CustomerDatabaseTable().insert(it.payload)
                            loadCustomersFromStorage()
                        }
                    }
                }
            }
        }
    }

    private fun loadCustomersFromStorage() {
        CustomerDatabaseTable().retrieve(business._id) { data ->
            scope.launch {
                repository.allCustomerState.emit(data)
            }
        }
    }

    @OptIn(ExperimentalTime::class)
    fun createNewCustomer(
        name: String,
        dialCode: String,
        mobile: String,
        email: String,
        Barcode: String,
        callBack: (Boolean) -> Unit
    ) {
        val request = CreateCustomerRequest(
            AuthHandler.shared().UserID,
            business._id,
            name,
            dialCode,
            mobile,
            email,
            Barcode,
            AuthHandler.shared().deviceId
        )
        startLoading()
        scope.launch {
            CustomerNetwork().createCustomer(request) {
                stopLoading()
                if (!it?.payload?._id.isNullOrEmpty()) {
                    callBack(true)
                    scope.launch {
                        CustomerHandler.shared().repository.customerState.emit(it!!.payload!!)
                        CustomerDatabaseTable().insert(item = it.payload)
                    }
                } else {
                    callBack(false)
                }
            }
        }
    }

    @OptIn(ExperimentalTime::class)
    fun updateCustomer(
        callBack: (Boolean) -> Unit
    ) {
        val request = editCustomer.value?.let {
            UpdateCustomerRequest(
                it._id,
                AuthHandler.shared().UserID,
                business._id,
                editCustomer.value?.Name ?: "",
                editCustomer.value?.DialCode ?: "",
                editCustomer.value?.MobileNumber ?: "",
                editCustomer.value?.EmailID ?: "",
                editCustomer.value?.Barcode ?: "",
                AuthHandler.shared().deviceId
            )
        }
        request?.let {
            startLoading()
            scope.launch {
                CustomerNetwork().updateCustomer(it) { response ->
                    stopLoading()
                    if (!response?.payload?._id.isNullOrEmpty()) {
                        callBack(true)
                        scope.launch {
                            CustomerHandler.shared().repository.customerState.emit(response!!.payload!!)
//                            repository.LastSyncDateState.emit(null)
                        }
                    } else {
                        callBack(false)
                    }
                }
            }
        }
    }
//
//    fun updateCustomer(customer: Customer) {
//        val user = FriendlyUser()
//        var request = JSONObject()
//        request.put(KeyConstant.UserID, user._id)
//        request.put(KeyConstant.BusinessID, BusinessHandler.shared().repository.business.value?._id)
//        request.put(KeyConstant.name, customer.Name)
//        request.put(KeyConstant.MobileNumberNumber, customer.MobileNumberNumber)
//        request.put(KeyConstant.emailId, customer.EmailID)
//        request.put(KeyConstant.Barcode, customer.Barcode)
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        SocketService.shared().send(SocketEvent.UPDATE_CUSTOMER, request)
//    }
//
//    fun insert(customer: Customer) {
//        CoroutineScope(Job() + Dispatchers.IO).launch {
//            DatabaseHandler.shared().database.customerDao()
//                .insert(customer)
//        }
//    }
//
//    fun getInvoiceCount(id: String, completion: (count: Int) -> Unit) {
//        if (!BusinessHandler.shared().repository.business.value?._id.isNullOrEmpty()) {
//            scope.launch {
//                val totalInvoiceCount =
//                    DatabaseHandler.shared().database.customerDao().getInvoiceCount(id)
//                if (totalInvoiceCount != null) {
//                    completion(totalInvoiceCount)
//                }
//            }
//        }
//    }
//
//    fun getTotalInvoiceValue(id: String, completion: (count: Float) -> Unit) {
//        if (!BusinessHandler.shared().repository.business.value?._id.isNullOrEmpty()) {
//            scope.launch {
//                val totalInvoiceValue =
//                    DatabaseHandler.shared().database.customerDao().getTotalInvoiceValue(id)
//                if (totalInvoiceValue != null) {
//                    completion(totalInvoiceValue)
//                }
//            }
//        }
//    }

    fun findCustomerByMobile(mobile: String, dialCode: String) {
        val request = FindCustomerRequest(
            "15143667976",
            dialCode,
            business._id
        )
        scope.launch {
            CustomerNetwork().findCustomerByMobile(request) {
                if (!it?.payload?._id.isNullOrEmpty()) {
                    scope.launch {
                        CustomerHandler.shared().repository.customerState.emit(it!!.payload!!)
                    }
                }
            }
        }
    }

    fun loadMembership(mobile: String, dialCode: String) {
        val membershipDetails = UserDefaults.shared().retrieveMembership(KeyConstant.membershipDetails)
        if (membershipDetails.isNotEmpty()) {
            val membership: Customer = jsonDecoder.decodeFromString(membershipDetails)
            scope.launch {
                CustomerHandler.shared().repository.customerState.emit(membership)
            }
        } else {
            val request = FindCustomerRequest(
                mobile,
                dialCode,
                business._id
            )
            scope.launch {
                CustomerNetwork().findCustomerByMobile(request) {
                    if (!it?.payload?._id.isNullOrEmpty()) {
                        scope.launch {
                            CustomerHandler.shared().repository.customerState.emit(it!!.payload!!)
                            UserDefaults.shared().store(
                                KeyConstant.membershipDetails,
                                jsonDecoder.encodeToString(Customer.serializer(),it.payload!!)
                            )
                        }
                    }
                }
            }
        }
    }
}